.itemUrl {
  &.hint {
    .hint {
      opacity: 1;
      height: 3rem;
    }
  }

  &.slow {
    .hint {
      transition-duration: 2500ms, 2000ms;
    }
  }

  .form {
    display: flex;
    width: 100%;

    .input {
      width: 100%;
      height: 2.875rem;
      margin-right: 0.75rem;

      @media (min-width: 400px) {
        height: 2.875rem;
      }
    }

    .button {
      flex: 0 0 auto;
      width: 2.5rem;
      height: 2.5rem;

      @media (min-width: 400px) {
        width: 2.75rem;
        height: 2.75rem;
      }

      svg {
        width: 1.375rem;
        height: 1.375rem;
        pointer-events: none;

        @media (min-width: 400px) {
          width: 1.5rem;
          height: 1.5rem;
        }
      }
    }
  }

  .hint {
    display: flex;
    opacity: 0;
    flex-direction: column;
    height: 0;
    margin-top: 0.625rem;
    overflow: hidden;
    transition:
      opacity 250ms cubic-bezier(0.22, 1, 0.36, 1),
      height 200ms cubic-bezier(0.22, 1, 0.36, 1);

    @media (min-width: 400px) {
      margin-top: 0.75rem;
    }

    .hintText {
      min-height: 1.375rem;
    }
  }
}
